<template>
  <div class="contents">
    <button class="menu-btn" @click="isActive01=!isActive01"><img class="" src="/img/60th-anniversary.png" alt="60YEARS Anniversary">MENU</button>
    <header class="contents__menu" @click="isActive01=!isActive01" v-bind:class='{active:isActive01}'>
      <div class="sidebar">
        <img class="sidebar__logo" src="/img/anniversary-logo.png" alt="" width="161" height="180">
        <router-link class="sidebar__item" to="/60th">
            <div class="sidebar__item--contents">
                <svg class="icon icon-flag"><use xlink:href="#icon-flag"></use></svg>
                <span>60年の歩み</span>
            </div>
        </router-link>
        <router-link class="sidebar__item" to="/60th/story" id="story">
            <div class="sidebar__item--contents">
                <svg class="icon icon-history"><use xlink:href="#icon-history"></use></svg>
                <span class="small">モーターサイクルスポーツの歴史</span>
            </div>
        </router-link>
        <router-link class="sidebar__item" to="/60th/champions" id="champions">
            <div class="sidebar__item--contents">
                <svg class="icon icon-champion"><use xlink:href="#icon-champion"></use></svg>
                <span>歴代チャンピオン</span>
            </div>
        </router-link>
        <router-link class="sidebar__item" to="/60th/archives" id="archives">
            <div class="sidebar__item--contents">
                <svg class="icon icon-mfj-riding"><use xlink:href="#icon-mfj-riding"></use></svg>
                <span>ARCHIVE SEARCH</span>
            </div>
        </router-link>
        <div class="sidebar__sns">
            <a href="https://www.facebook.com/mfj.or.jp/" target="_blank" rel="noopener">
                <svg class="icon icon-facebook"><use xlink:href="#icon-facebook"></use></svg>
            </a>
            <a href="https://twitter.com/MFJoffice" target="_blank" rel="noopener">
                <svg class="icon icon-twitter"><use xlink:href="#icon-twitter"></use></svg>
            </a>
            <a href="https://www.youtube.com/c/MFJofficial" target="_blank" rel="noopener">
                <svg class="icon icon-youtube"><use xlink:href="#icon-youtube"></use></svg>
            </a>
        </div>
        <a class="magazine-link" href="https://mfj.or.jp/" title="MFJ ONLINE MAGAZINEへ" target="_blank" rel="noopener noreferrer"><img src="/img/mfj-online-magazine.svg" alt="MFJ ONLINE MAGAZINE" width="208" height="80"></a>
      </div>
    </header>
    <main class="contents__main">
        <div class="top">
            <img class="top__mark" src="/img/60th-anniversary.png" alt="60YEARS Anniversary">
            <h1 class="top__title"></h1>
            <div class="checker"></div>
            <p class="top__en"></p>
        </div>
        <small class="copy-right">© Motorcycle Federation of Japan. All rights reserved.</small>
      <!--上記のリンクタグで設定したコンポーネントが表示される場所です。-->
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  data: function() {
      return {
        isActive01: false
      }
  },
  methods : {
    createTitleDesc : function(routeInstance){
         // タイトルを設定
        if(routeInstance.meta.title){
            var setTitle = routeInstance.meta.title,
                setTitleMeta = setTitle + ' | MFJ60',
                setTitleSub = routeInstance.meta.en;
            document.title = setTitleMeta;
            document.querySelector("h1").innerText = setTitle;
            document.querySelector(".top__en").innerText = setTitleSub;
        }

        // メタタグdescription設定
        if(routeInstance.meta.desc){
            var setDesc = routeInstance.meta.desc;
            document.querySelector("meta[name='description']").setAttribute('content', setDesc)
        }
    },
  },
  mounted : function(){
      var routeInstance = this.$route;
      this.createTitleDesc(routeInstance);
      //パラメータのvalueを変数に入れる→その変数でif文 router-linkのID
      //条件でパラメータのvalueがstoryかchanpionsかarchiveのときのみ
      //クリックさせる
      var url = new URL(window.location.href);
      var params = url.searchParams;
      var pageInstance = params.get('page');
      if(pageInstance == 'story' || pageInstance == 'champions' || pageInstance == 'archives' ){
          document.getElementById(pageInstance).click();
      }
  },
  watch: { 
      '$route' (routeInstance) {
          this.createTitleDesc(routeInstance);
      }
  } 
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700&display=swap');
body{
  margin: 0;
}
#app {
  font-family: "Helvetica Neue", Arial,"Hiragino Kaku Gothic ProN","Hiragino Sans",Meiryo,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1A1311;
  letter-spacing: 2px;
}
p{
    line-height:2;
}
.contents{
  &__menu{
    width: 245px;
    height: 100vh;
    background: #f5f5f5;
    background: linear-gradient(235deg, #fff 10%, #a0a0a0 100%);
    position: fixed;
    top: 0;
    left: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &__main{
    width: calc(100% - 245px);
    margin-left: 245px;
    position: relative;
    &:before{
        content: "";
        position: fixed;
        width: calc(100% - 245px);
        height: 100vh;
        z-index: 0;
        top: 0;
        right: 0;
        background-image: url(/img/about-back.png);
        background-repeat: no-repeat;
        background-position: right 20px bottom 35px;
        z-index: -1;
        @media(min-width:1050px){
            background-attachment: fixed;
        }
    }
    &:after{
        content: "";
        position: fixed;
        top: 0;
        right: 0;
        background: rgb(255,255,255);
        background: radial-gradient(circle, #f5f5f5 29%, rgba(204,204,204,1) 100%);
        display: block;
        width: calc(100% - 245px);
        height: 100vh;
        z-index: -2;
    }
  }
}
.sidebar {
    display: flex;
    flex-flow: column;
    a{
        color: #1A1311;
        text-decoration: none;
        text-align: center;
    }
    &__logo{
        display: block;
        margin: 20px auto 30px;
    }
    &__item{
        border: solid 1px #ccc;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 60px;
        margin: 0 10px 15px;
        &--contents{
            display: flex;
            flex-direction: column;
        }
    }
    &__sns{
        display: flex;
        align-items: center;
        width: 125px;
        justify-content: space-between;
        margin: 0 auto;
        a {
            margin-top: 1em;
        }        
    }
    @media(max-height:767px){
        &__item{
            height: 50px;
            .icon{
                height: 22px;
            }
        }
    }
}
.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
    margin: 0 auto;
    margin-bottom: 10px;
    height: 32px;
    width: 210px;
    
}
.icon.icon-mfj-riding{
    width: 200px;
}
.icon.icon-facebook{
    width: 15px;
    height: 15px;
}
.icon.icon-twitter{
    width: 15px;
    height: 15px;
}
.icon.icon-youtube {
    width: 60px;
    height: 15px;
}

.top{
    background: #1A1311;
    display: flex;
    position: relative;
    margin-bottom: 120px;
    &__mark{
        position: absolute;
        left: 20px;
        top: 20px;
    }
    &__title{
        color: #ffffff;
        margin-top: 0;
        margin-bottom: 0;
        padding-top: 27px;
        padding-bottom: 27px;
        margin-left: 200px;
        font-family: serif;
        font-size: 36px;
    }
    &__en{
        position: absolute;
        right: 10px;
        top: 100%;
        font-size: 7.2vw;
        color: #CB0010;
        font-weight: bold;
        font-family: serif;
        margin: 0;
        line-height: 1;
        text-align: right;
        @media(min-width:1250px){
            font-size: 90px;
        }
    }
}
.wrap {
    padding: 30px;
}

/* アニメーション中のスタイル */
.v-leave-active,
.v-enter-active {
  transition: opacity .5s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transition: .5s;
}

.checker {
    $main: #1A1311;
    $bk: #dddddd;
    position: absolute;
    margin: 0;
    width: 20%;
    min-width: 150px;
    height: 100%;
    background:
    // linear-gradient(45deg, $main 25%, transparent 25%, transparent 75%, $main 75%),
    // linear-gradient(45deg, $main 25%, transparent 25%, transparent 75%, $main 75%);
    linear-gradient(45deg, $main 25%, transparent 25%, transparent 75%, $main 75%),
    linear-gradient(45deg, $main 25%, transparent 25%, transparent 75%, $main 75%);
    background-size: 72px 72px;
    background-position: 36px 0, 0 36px;
    background-color: $bk;
    top: 0;
    right: 0;
    border: none;
}

.magazine-link {
    display: block;
    margin-top: 40px;
}
.copy-right {
    position: fixed;
    bottom: 10px;
    right: 10px;
    writing-mode: vertical-lr;
    font-size: 10px;
    z-index: 2;
}
.small{
    font-size: .8em;
    letter-spacing: 0;
}
/*スクロールバー全体*/
::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

/*スクロールバーの軌道*/
::-webkit-scrollbar-track {
    background: #ddd;
    box-shadow: 1px 1px 1px rgba(#fff,.1);
}

/*スクロールバーの動く部分*/
::-webkit-scrollbar-thumb {
  background-color: #aaa;
  border-radius: 2px;
}
@media(max-width:1023px){
    .contents{
        &__menu{
            left: -250px;
            z-index: 2;
            transition: .5s;
            &.active{
                left: 0;
            }
        }
        &__main{
            width: 100%;
            margin-left: 0;
            &:before{
                width: 100%;
            }
            &:after{
                width: 100%;
            }
        }
    }
    .top{
        background: linear-gradient(90deg, #1A1311 0%, #1A1311 50%, transparent 50%, transparent 100%);
        margin-bottom: 20px;
        &__mark{
            display: none;
        }
        &__title{
            margin-left: 80px;
            font-size: 24px;
            background: #1a1411;
            padding: 11px 0;
            width: calc(100% - 150px);
        }
    }
    .checker {
        background: linear-gradient(45deg, #1A1311 25%, transparent 25%, transparent 75%, #1A1311 75%),
                  linear-gradient(45deg, #1A1311 25%, transparent 25%, transparent 75%, #1A1311 75%);
        background-size: 40px 40px;
        background-position: 0 0, 20px 20px;
        z-index: -1;
    }
}
@media(max-width:767px){
    .top__en{
        font-size: 11vw;
        right: 0;
    }
    .copy-right{
        right: 0;
    }
    .contents__main:before {
        background-position: right 0px top 200px;
        background-size: contain;
    }
}
.menu-btn{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    border: none;
    color: #a38712;
    background: #1a1411;
    padding: 4px 20px;
    font-family: "Barlow Condensed", sans-serif;
    letter-spacing: 3px;
    text-align: center;
    img{
        display: block;
        width: 36px;
        margin: 0 auto;
    }
    @media(min-width:1024px){
        display: none;
    }
}
</style>
